import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function createEnquiry(payload) {
  const { data } = await api.post("/enquiries", payload);
  return data;
}

export async function fetchServices() {
  const { data } = await api.get("/services");
  return data;
}

export async function fetchService(slug) {
  const { data } = await api.get(`/services/${slug}`);
  return data;
}

export async function fetchReviews() {
  const { data } = await api.get("/reviews");
  return data;
}

export async function fetchFaqs() {
  const { data } = await api.get("/faqs");
  return data;
}
